import { Form, Input, Modal, Alert, Button } from "antd";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import skrActions from "../../../pages/S2R/redux/actions";
import contactService from "../../services/contact-service";

const ContactSupport = () => {
  const dispatch = useDispatch();
  const isModalVisible = useSelector((state) => state.s2r.contactOpen);
  const [form] = Form.useForm();

  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleOk = () => {
    dispatch(skrActions.contactOpen(false));
  };

  const handleCancel = () => {
    dispatch(skrActions.contactOpen(false));
  };
  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      await contactService.contactSupport(values);
      setSuccess(true);
    } catch (e) {
      setIsLoading(false);
    }
    setIsLoading(false);
    setSuccess(true);
  };

  return (
    <Modal
      centered
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={700}
      height={700}
    >
      <Form form={form} onFinish={handleSubmit} layout="vertical">
        <div className="row" style={{ padding: "1rem" }}>
          <h1
            style={{ textAlign: "center", color: "#E5E5E5", fontSize: "14px" }}
          >
            Leave us a message
          </h1>
          <div className="col s12 m12 l12">
            <div className="row">
              <div className="col s12 m12 l12 inputs">
                <Form.Item name="name" label="Name">
                  <Input
                    placeholder=" Your name"
                    className="test"
                    style={{
                      backgroundColor: "#212121",
                      border: "1px solid #707070",
                      color: "#E5E5E5",
                    }}
                  />
                </Form.Item>
                <Form.Item name="email" label="Email">
                  <Input
                    placeholder=" Email address"
                    className="test"
                    style={{
                      backgroundColor: "#212121",
                      border: "1px solid #707070",
                      color: "#E5E5E5",
                    }}
                  />
                </Form.Item>

                <Form.Item name="message" label="Message">
                  <Input.TextArea
                    style={{
                      backgroundColor: "#212121",
                      border: "1px solid #707070",
                      height: "300px",
                      color: "#E5E5E5",
                    }}
                  />
                </Form.Item>
                <Form.Item>
                  {!success ? (
                    <Button
                      className="send-btn"
                      type="primary"
                      style={{
                        width: "100%",
                        backgroundColor: "#256AFE",
                        border: "none",
                      }}
                      htmlType="submit"
                      loading={isLoading}
                    >
                      Send
                    </Button>
                  ) : (
                    <Alert
                      message="Message Sent! We will get back with you very soon."
                      type="success"
                      showIcon
                    />
                  )}
                </Form.Item>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
};
export default ContactSupport;
